import React from 'react'
import {
    Switch,
    Route,
} from "react-router-dom";

import PrivateRoute from "../guard/auth";

import Page from './Page'
import Login from './Login'
import ForgetPassword from './ForgetPassword'
import ResetPassword from './ResetPassword'
import Approve from './ApproveList/Approve'
import LeavePDF from '../components/report/LeavePDF'
import SalaryDetail from './Salarys/SalaryDetailSimlex'
// import ServerMaintenance from './ServerMaintenance'

const MainPage = () => {
    return (
        <>
            <Switch>
                <Route exact path="/">
                    <Login />
                </Route>
                <Route path="/forget-password">
                    <ForgetPassword />
                </Route>
                <Route path="/reset-password">
                    <ResetPassword />
                </Route>
                <PrivateRoute path="/leave-detail/:id">
                    <Approve />
                </PrivateRoute>
                <Route path="/pdf/:id">
                    <LeavePDF />
                </Route>
                <Route path="/salary/:id">
                    <SalaryDetail />
                </Route>
                {/* 
                <Route path="/maintenance">
                    <ServerMaintenance />
                </Route>
                */}
                <Page />
            </Switch>

        </>
    )
}

export default MainPage
